{
  "version": 2,
  "note": "The locked art framework. Changing anything here needs the owner's approval; see docs/art/STYLE-GUIDE.md.",
  "transparent": ".",
  "outlineColors": ["#23140b", "#18100b", "#1a0f09"],
  "maxColorsPerAsset": 24,
  "masterPalette": {
    "ink": ["#23140b", "#18100b", "#1a0f09", "#14110f"],
    "umber": ["#472713", "#633616", "#7d471e", "#9b5d27", "#3d2210", "#3b2a20"],
    "gold": ["#be7934", "#d89648", "#eab263", "#e6b832", "#f7d969"],
    "cream": ["#b89062", "#dcc096", "#efe0c2", "#ebe2d5"],
    "red": ["#731c1c", "#a82c2c", "#cf4a4a"],
    "pink": ["#ad4459", "#d9687e"],
    "neutral": ["#4a4540", "#7a736b", "#aaa399", "#d6d0c6", "#f5f1e8"],
    "green": ["#2f4a24", "#46702f", "#6a9a3f", "#97c25a", "#c6e08a"],
    "blue": ["#2c4a7a", "#4a78b0", "#7aa8d8", "#addaf0", "#dff1fa"],
    "teal": ["#1f4f5a", "#2f7d86", "#4fa8a8", "#86d0c4"],
    "sand": ["#8a6f45", "#b8996a", "#d9c08e", "#efe0b8"],
    "orange": ["#a34a1c", "#d8742a", "#f0a04a", "#f7c77a"],
    "purple": ["#4a3066", "#6f4f9a", "#9a7bc4", "#c9b0e6"]
  },
  "classes": {
    "pet": {
      "size": { "w": 40, "h": 40 },
      "anchor": { "x": 19, "y": 38 },
      "requiredFrames": ["sit_0", "sit_1", "sit_blink_0", "sit_blink_1", "sit_happy_0", "sit_happy_1", "eat", "lie"],
      "allowedFramePattern": "^(sit_[0-9]|sit_blink_[0-9]|sit_happy_[0-9]|eat(_[0-9])?|lie(_[0-9])?|(play|wash|sleep|sad|jump)_[0-9])$",
      "outlineRequired": true,
      "groundLine": true
    },
    "swimmer": {
      "size": { "w": 40, "h": 40 },
      "anchor": { "x": 19, "y": 20 },
      "requiredFrames": ["swim_0", "swim_1", "swim_happy_0", "swim_happy_1", "eat", "rest", "sad_0"],
      "allowedFramePattern": "^(swim_[0-9]|swim_blink_[0-9]|swim_happy_[0-9]|eat(_[0-9])?|rest(_[0-9])?|(play|wash|sleep|sad)_[0-9])$",
      "outlineRequired": true,
      "groundLine": false
    },
    "icon": {
      "size": { "w": 16, "h": 16 },
      "anchor": { "x": 8, "y": 8 },
      "requiredFrames": [],
      "allowedFramePattern": "^[a-z][a-z0-9-]*$",
      "outlineRequired": true,
      "groundLine": false,
      "anchorPixel": false
    }
  },
  "animation": { "maxFps": 4, "maxFramesPerAnimation": 4 }
}
